import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {StorageService, TranslateHelperService} from '@services';

const toPath = (segments: string[]): string => {
	if (!segments || segments.length === 0) {
		return '/';
	}
	return `/${segments.filter(Boolean).join('/')}`;
};

export const redirectLoggedInToStorage: (redirectTo: string[]) => CanActivateFn = (redirectTo) => {
	return () => {
		const router = inject(Router);
		const translateService = inject(TranslateHelperService);
		const storageService = inject(StorageService);
		const isLoggedIn = storageService.get('isLoggin') === 'true';
		if (isLoggedIn) {
			router.navigateByUrl(translateService.localize(toPath(redirectTo)));
			return false;
		}
		return true;
	};
};
